module.exports = __webpack_public_path__ + "static/media/service-window-sku-1.90fcea56.png";